import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';
import ManhwaCard from '@/components/feature/ManhwaCard';

export default function Featured() {
  const featured = manhwaList.filter((m) => m.recommended);
  const spotlight = featured[0];
  const rest = featured.slice(1);

  return (
    <section id="featured" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-award-fill" /> 编辑精选
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">韩漫精选必看</h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600">
              从本站收录的作品里，挑出最值得入坑的几部高分佳作，口碑与热度兼备，闭眼追不会错。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <Link
            to={`/detail/${spotlight.id}`}
            className="group relative overflow-hidden rounded-2xl bg-foreground-950 lg:col-span-2 lg:row-span-2"
          >
            <img
              src={spotlight.cover}
              alt={`${spotlight.title} 韩漫精选推荐封面`}
              title={`${spotlight.title} 韩漫推荐必看`}
              className="h-[320px] w-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-105 lg:h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded-full bg-accent-500 px-2.5 py-1 font-bold text-background-950">
                  <i className="ri-star-fill" /> {spotlight.score.toFixed(1)}
                </span>
                <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-background-50 backdrop-blur">
                  {spotlight.status}
                </span>
                {spotlight.tags.map((t) => (
                  <span key={t} className="rounded-full bg-background-50/20 px-2.5 py-1 text-background-50 backdrop-blur">
                    {t}
                  </span>
                ))}
              </div>
              <h3 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {spotlight.title}
              </h3>
              <p className="mt-2 max-w-xl text-sm leading-6 text-background-200">{spotlight.summary}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-accent-300">
                查看推荐详情 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>

          {rest.map((item) => (
            <ManhwaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}